import { useMutation, useQueryClient } from '@tanstack/react-query';
import { App } from 'antd';

import {
  markOrderNotificationReadOptions,
  orderNotificationsOptions,
} from '@lib/api/options/orders';
import { MutationCallbackOptions } from '@lib/api/options/types';
import { getRateLimitMessage } from '@lib/utils/error-handler';

export const useMarkOrderNotificationRead = () => {
  const { message } = App.useApp();
  const queryClient = useQueryClient();
  const { mutateAsync: onRead, isPending: reading } = useMutation(
    markOrderNotificationReadOptions(),
  );

  const handleOnRead = (
    id: string,
    callbacks?: MutationCallbackOptions<Awaited<ReturnType<typeof onRead>>>,
  ) =>
    onRead(id, {
      onSuccess: async () => {
        queryClient
          .invalidateQueries({
            queryKey: orderNotificationsOptions().queryKey,
          })
          .catch(() => undefined);
        callbacks?.onCompleted?.();
      },
      onError: (error) => {
        message.error(
          getRateLimitMessage(error) ??
            'Não foi possível marcar a notificação como lida. Tente novamente.',
        );
        callbacks?.onError?.(error);
      },
    });

  return { markRead: handleOnRead, reading };
};
